<template>
<div>
	<div class="d-flex justify-content-between align-items-center">
		<field label="Report Type"
			col-class="col-auto"
			:params="{type:'select',options:[
				{text: 'Total Billing',value:'total-billing'},
				{text: 'Billing Over Time',value: 'monthly-billing'}
			]}"
			v-model="localSelectedType"
			v-on:change="$emit('selectedTypeChange',$event)">
		</field>

		<div class="d-flex">
			<field 
				label="Range"
				col-class="col-auto"
				:params="{type:'select',options: [
					{text: 'Last 3 Months',value:3},
					{text: 'Last 6 Months',value:6},
					{text: 'Last 12 Months',value:12},
					{text: 'Last 24 Months',value:24},
					{text: 'Last 5 Years',value:60}
				]}"
				v-model="reportPeriod"
				v-on:change="periodChange">
			</field>

		</div>
	</div>

	<h3>Total Billing Over Time</h3>

	<chart v-if="renderGraph"
		height="300"
		type="line"
		:datasets="renderedReport.datasets"
		:labels="periodLabels"
		:options="lineChartOptions"
		v-on:click="chartClick">
	</chart>

	<div v-if="detailView" class="mt-4">
		<div class="d-flex justify-content-between">

			<h3>Project Breakdown for Period of {{moment(selectedPeriodDate).format("MMM YYYY")}}</h3>

			<i class="icon-button fa fa-times" v-on:click="detailView = false"></i>
		</div>

		<info-box style="display: inline-block;float:right;" label="Total Revenue" :value="selectedPeriodRevenue"></info-box>

		<table-list v-if="detailView"
			:record-name="tableRecordName"
			:fields="fields"
			:hide-record-count="true"
			:sortable="true"
			:records="invoicesMutatedToProjects">
		</table-list>
	</div>

</div>
</template>
<script type="text/javascript">
import Field from "@/components/Field"
import TableList from "@/components/TableList"
import ProgressBar from "@/components/ProgressBar"
import Widget from "@/components/Widget"
import ContextMenu from "@/layout_fragments/ContextMenu"
import InfoBox from "@/components/InfoBox"

import Chart from "@/components/Chart"

export default {
	name: "MonthlyBillingReport",
	components: {
		Field,
		TableList,
		Chart,
		InfoBox
	},
	props: ["selectedType"],
	data() {
		return {
			localSelectedType: this.selectedType,
			detailView: false,
			reportRecords: [],
			renderedReport: {},
			invoices: [],
			selectedPeriodDate: null,
			renderGraph: false,
			reportPeriod: 6,
			selectedDateRange: {
				from_year: 2020,
				from_month: 1,
				to_year: 2020,
				to_month: 12
			},
			page: 1,
			numPages: 0
		}
	},
	watch: {
		selectedType() {
			this.localSelectedType = this.selectedType
		}
	},
	computed: {
		datasetLabel() {
			if (this.numPages == 1)
				return "Total Billing All Projects"
			else
				return "Total Billing All Projects (page "+this.page+")"
		},
		lineChartOptions() {
			return {
				tooltips: {
					callbacks: {
						label(item,data) {
							let value = +item.value

							return "$ " + value.toCurrency()
						}
					}
					
				},
				scales: {
					yAxes: [{
						ticks: {
							callback(value,index,values) {
								return '$ '+ value.toCurrency()
							}
						}
					}]
				}
			}
		},
		tableRecordName() {
			return "Project"
		},
		totalBillingDataset() {
			let dataset = [], vm = this

			this.periodLabels.forEach(label => {
				dataset.push(0)
			})

			this.mutatedToProjects.forEach(job => {
				vm.fields.forEach((field,index) => {
					if (index > 2 && job[field.key+"_raw"]) {
						dataset[index-3] += +job[field.key+"_raw"]
					}
					
				})
			})

			return dataset
		},
		periodLabels() {
			let labels = []

			let dateStart = this.moment(this.dateStart.format("YYYY-MM-DD"))

			if (this.reportPeriod > 24) {
				dateStart.add(1,"year")
				while (this.dateEnd.isAfter(dateStart)) {
					labels.push(dateStart.format("YYYY"))

					dateStart.add(1,"year")
				}
			}
			else {
				dateStart.add(1,"month")
				while (this.dateEnd.isAfter(dateStart)) {
					labels.push(dateStart.format("MMM YYYY"))

					dateStart.add(1,"month")
				}
			}

			return labels		},
		fields() {
			let fields = [
				{label: "Project #",key:'jobNum',type:'link'},
				{label: "Project Name",key:"job_name"},
				{label: "Total Period Revenue",key:'periodRevenue',align:"right"}
			]

			/*let dateStart = this.moment(this.dateStart.format("YYYY-MM-DD"))

			if (this.reportPeriod == 'last-5-years') {
				dateStart.add(1,"year")
				while (this.dateEnd.isAfter(dateStart)) {
					fields.push({
						label: dateStart.format("YYYY"),
						key: dateStart.format("YYYY"),
						align: "right"
					})

					dateStart.add(1,"year")
				}
			}
			else {
				dateStart.add(1,"month")
				while (this.dateEnd.isAfter(dateStart)) {
					fields.push({
						label: dateStart.format("MMM YYYY"),
						key: dateStart.format("MMMYYYY"),
						align: "right"
					})

					dateStart.add(1,"month")
				}
			}*/

			return fields
		},
		selectedPeriodRevenue() {
			let total = this.invoicesMutatedToProjects.reduce((acc,job) => +acc + job.periodRevenueRaw,0)

			return "$ "+total.toCurrency()
		},
		invoicesMutatedToProjects() {
			let vm = this

			let jobs = []

			this.invoices.forEach(inv => {
				let jobIndex = jobs.findIndex(job => job.id == inv.Job.id)

				if (jobIndex == -1) {
					jobs.push({
						id: inv.Job.id,
						jobNum: {text:inv.Job.job_num,link: "/project/"+inv.Job.slug+"/dashboard"},
						job_name: inv.Job.job_name,
						periodRevenueRaw: +inv.pretax_total
					})
				}
				else 
					jobs[jobIndex].periodRevenueRaw += +inv.pretax_total
			})

			return jobs.map(job => {
				job.periodRevenue = job.periodRevenueRaw.toCurrency()

				return job
			})
		},
		dateStart() {
			return this.moment().subtract(this.reportPeriod,"months")
		},
		dateEnd() {
			return this.moment()
		},
	},
	methods: {
		periodChange() {
			let vm = this
			this.$nextTick(() => {
				vm.fetchReport()
			})
		},
		chartClick(activePoints) {
			let vm = this
			if (activePoints.length > 0) {
				let index = activePoints[0]._index
				//find period from index

				let periodDate = this.moment(this.dateStart.format("YYYY-MM-DD"))
				let interval = 'month'

				let cnt = 0
				if (this.reportPeriod > 24) {
					interval = "year"
					periodDate.add(1,"year")
				}
				else 
					interval = "month"

				while (this.dateEnd.isAfter(periodDate)) {
					if (cnt == index) 
						break;
					
					cnt++
					periodDate.add(1,interval)
				}

				this.selectedPeriodDate = periodDate

				this.fetchInvoicesByPeriod(periodDate,interval)	
			}
		},
		renderReport(reportRecords) {
			let vm = this
			let revenue = [], expenses = [], labour = [], labels = []

			if (this.reportPeriod > 24) {
				let yearDiff = (this.reportPeriod / 12) - 1

				let currentYear = 0;
				//we need to condense monthly reports into yearly
				reportRecords.forEach(record => {

					if (+record.year >= +vm.moment().format("YYYY") - yearDiff) {

						let datapoints = {}
						try {
							datapoints = JSON.parse(record.report_json)
						}
						catch (e) {}

						if (+record.year > currentYear) {
							currentYear = +record.year
							
							if ("revenue" in datapoints)
								revenue.push(datapoints.revenue)
							if ("expenses" in datapoints)
								expenses.push(datapoints.expenses)
							if ("labour" in datapoints)
								labour.push(datapoints.labour)
						}
						else {
							revenue[revenue.length - 1] += +datapoints.revenue
							expenses[expenses.length - 1] += +datapoints.expenses
							labour[labour.length - 1] += +datapoints.labour
						}
					}
				})
			}
			else {
				reportRecords.forEach(record => {
					let datapoints = {}
					try {
						datapoints = JSON.parse(record.report_json)
					}
					catch (e) {}

					if ("revenue" in datapoints)
						revenue.push(datapoints.revenue)
					if ("expenses" in datapoints)
						expenses.push(datapoints.expenses)
					if ("labour" in datapoints)
						labour.push(datapoints.labour)

				})
			}

			return {
				labels: this.periodLabels,
				datasets: [
					{
						label: 'Gross Revenue',
						lineTension: 0,
						borderColor: '#ECBA00',
						fill: false,
						data: revenue
					},
					{
						label: 'Labour',
						lineTension: 0,
						borderColor: 'blue',
						fill: false,
						data: labour
					},
					{
						label: 'Expenses',
						lineTension: 0,
						borderColor: 'red',
						fill: false,
						data: expenses
					}
				]
			}
		},
		fetchInvoicesByPeriod(periodDate,interval) {
			let vm = this

			let periodStart = periodDate.startOf(interval).format("YYYY-MM-DD")
			let periodEnd = periodDate.endOf(interval).format("YYYY-MM-DD")

			let params = {
				include: [
					{
						model: "Job",
						include: [{model: "Contact",fields: ["id","slug","name"]}],
						fields: ["id","slug","job_name","job_num","customer_id"]
					}
				],
				filters: [
					["issue_date >=",periodStart],
					["issue_date <=",periodEnd],
					["is_finalized",1],
					["is_active_version",1]
				]
			}

			this.spinner(true)

			this.getJSON("JobInvoice/get",params).then(response => {
				if (response.success) {
					vm.invoices = response.data
					this.detailView = true
				}
			
				vm.spinner(false)
			})
		},
		fetchReportRange(params) {
			let vm = this

			this.renderGraph = false

			return new Promise((resolve,reject) => {
				vm.getJSON("JobReport/get-range",params).then(response => {
					if (response.success) {
						vm.renderGraph = true

						vm.reportRecords = response.data
						vm.renderedReport = vm.renderReport(response.data)
					}

					resolve(response)
				})
			})
		},
		fetchReport() {
			let vm = this

			let fromDate = this.moment().subtract(this.reportPeriod,"months")

			this.spinner(true)

			this.fetchReportRange({
				report_type: "total-monthly-billing",
				from_year: fromDate.format("YYYY"),
				from_month: fromDate.format("MM"),
				to_year: this.moment().format("YYYY"),
				to_month: this.moment().format("MM")
			}).then(response => {
				vm.spinner(false)
			})
		},
	},
	created() {
		let vm = this

		this.fetchReport()
	}
}
</script>